import React, { useEffect, useState } from 'react';
import IFeature from "../../../types/feature";
import Button from "../elements/Button";
import { getSortingSteps } from "../../../utils/content";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { featureAPI } from "../../../api/feature";
import ICommonOptions from "../../../types/commonOptions";
import { setOptionsAction } from "../../../store/reducers/commonSlice";
import { userAPI } from "../../../api/user";
import IUserOption from "../../../types/userOption";

export const inputClassName = 'block w-full flex-1 rounded-none rounded-r-sm border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-3 py-1 rounded-l-md'
export const labelClassName = 'inline-flex items-center rounded-l-sm border border-r-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500 w-[50%]'

const steps = getSortingSteps()

const UserOptionsForm = ({ onClose }: { onClose: () => void }) => {
    const userOptions = useAppSelector(state => state.user.options)

    const [updateOptions] = userAPI.useUpdateOptionsMutation()
    const [optionsState, setOptionsState] = useState<IUserOption | null>(userOptions)

    const changeOptionsState = (field: keyof IUserOption, value: any) => {
        if (!optionsState) return;
        if (value === undefined) return;
        setOptionsState({
            ...optionsState,
            [field]: value
        })
    }

    const saveOptions = () => {
        if (optionsState)
            updateOptions(optionsState)
        onClose()
    }

    if (!optionsState) {
        return <></>;
    }

    return (
        <form className="space-y-6" action="#">
            <div className="mb-4 flex flex-col items-center">
                <div className="w-full mb-1">
                    <div className="flex rounded-md shadow-sm w-full">
                        <label className={labelClassName}>Skip Initial Message</label>
                        <select
                            value={optionsState.skipInitialMessage ? 1 : 0}
                            name="revisionsStep"
                            className="py-2 px-4 border-[2px] outline-none w-[50%]"
                            onChange={(e) => changeOptionsState('skipInitialMessage', +e.target.value !== 0)}
                        >
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                        </select>
                    </div>
                </div>
                <div className="w-full mb-1">
                    <div className="flex rounded-md shadow-sm w-full">
                        <label className={labelClassName}>Add Talk Page</label>
                        <select
                            value={optionsState.addTalkPage ? 1 : 0}
                            name="addTalkPage"
                            className="py-2 px-4 border-[2px] outline-none w-[50%]"
                            onChange={(e) => changeOptionsState('addTalkPage', +e.target.value !== 0)}
                        >
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                        </select>
                    </div>
                </div>
                <div className="w-full mb-1">
                    <div className="flex rounded-md shadow-sm w-full">
                        <label className={labelClassName}>Excluded Accounts</label>
                        <textarea
                            className="py-2 px-4 border-[2px] outline-none w-[50%]"
                            onChange={(e) => changeOptionsState('excludedAccounts', e.target.value)}
                            value={optionsState.excludedAccounts}
                            rows={5}
                        />
                    </div>
                </div>
                <div className="w-full">
                    <div className="flex rounded-md shadow-sm w-full">
                        <label className={labelClassName}>Revisions step</label>
                        <select
                            value={optionsState.revisionsStep}
                            name="revisionsStep"
                            className="py-2 px-4 border-[2px] outline-none w-[50%]"
                            onChange={(e) => changeOptionsState('revisionsStep', e.target.value)}
                        >
                            {steps.map((step: number) => <option key={step} value={step}>
                                {step}
                            </option>)}
                        </select>
                    </div>
                </div>
            </div>
            <div className="">
                <Button
                    type="button"
                    label="Save"
                    onClick={saveOptions}
                />
            </div>
        </form>
    );
};

export default UserOptionsForm;